import React from "react";
import { Accordion } from "react-accessible-accordion";
import "assets/scss/helpers/accordion.scss";

export default ({ children, onChange, className }) => {
  return (
    <Accordion
      allowZeroExpanded={true}
      className={className}
      onChange={onChange}
    >
      {children}
    </Accordion>
  );
};
